module.exports = require("ng2-uploader/src/services/ng2-uploader");